import supabaseClient from '@/api/supabaseClient.ts';
import { RegionRepository as SharedRegionRepository } from '$/repositories/regionRepository/RegionRepository.ts';

const regionRepository = new SharedRegionRepository(supabaseClient);
export default regionRepository;
